import request from '../../../helpers/request';

export const getInfoAttachData = async (infoId, fileName, path = 'preview') => {
  return await request.get(
    `/Information/${path}`,
    { infoId, fileName },
    `При загрузке файла ${fileName} произошла ошибка`
  );
};
